<script setup>
import { ref, computed, watch } from 'vue';
import {
  parsePhosphorIcon,
  getCachedPhosphorBody,
  getPhosphorBody,
} from 'shared/helpers/phosphorIcons';

const props = defineProps({
  // 'i-ph-<name>' or 'i-ph-<name>;<color>' as stored by the icon picker
  icon: { type: String, required: true },
  // overrides the colour embedded in `icon`
  color: { type: String, default: '' },
});

const parsed = computed(() => parsePhosphorIcon(props.icon));
const name = computed(() => parsed.value?.name ?? '');
const iconColor = computed(() => props.color || parsed.value?.color || '');
const body = ref('');

watch(
  name,
  async current => {
    body.value = getCachedPhosphorBody(current) ?? '';
    if (body.value || !current) return;
    const loaded = await getPhosphorBody(current);
    // ignore a load that finished after the icon changed again
    if (current === name.value) body.value = loaded;
  },
  { immediate: true }
);
</script>

<template>
  <!-- Bodies are trusted build-time data keyed by a validated icon name. -->
  <!-- eslint-disable-next-line vue/no-v-html -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    class="inline-block shrink-0"
    :data-icon="name"
    :style="iconColor ? { color: iconColor } : undefined"
    v-html="body"
  />
</template>
